// extracted by mini-css-extract-plugin
module.exports = {"tile":"package-tile_tile__3hwL_","labels":"package-tile_labels__wPEJ2","name":"package-tile_name__kcCdN","count":"package-tile_count__lYINa","cta":"package-tile_cta__PFQFW"};